import { Link } from 'react-router-dom';

import { truncateText } from '@ui-framework/index';

function formName(original) {
  return (
    <Link to={`/servicejobforms/edit/${original?.id}`}>
      {original?.formName || ''}
    </Link>
  );
}

function checkOrder(original) {
  return original?.checkOrder || '';
}

function formUiSchema(original) {
  return truncateText(JSON.stringify(original?.formUiSchema) || '');
}

export { formName, checkOrder, formUiSchema };
